import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Pagination from "react-js-pagination";
import "../Inventory/Inventory.css";
import { getSamrtProducts } from "../../services/api/ProductAPI";

class PincodeSmartProductOffer extends Component {
  constructor() {
    super();
    this.state = {
      products: [],
      searchText: "",
      activePage: 1,
      itemsCountPerPage: 50,
      totalItemsCount: 0,
      recordFrom: 0,
      paginationStatus: "No records to display",
      loading: false,
      selectedProducts: [],
      viewMode: "table", // 'grid' or 'table'
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.toggleProductSelection = this.toggleProductSelection.bind(this);
    this.handlePrint = this.handlePrint.bind(this);
    this.toggleViewMode = this.toggleViewMode.bind(this);
    this.toggleSelectAll = this.toggleSelectAll.bind(this);
    this.showPaginationStatus = this.showPaginationStatus.bind(this);
    this.loadProducts = this.loadProducts.bind(this);
  }

  componentDidMount() {
    this.loadProducts(
      this.state.searchText,
      this.state.recordFrom,
      this.state.itemsCountPerPage
    );
  }

  async loadProducts(searchText = "", from, size) {
    this.setState({ loading: true });

    let res = await getSamrtProducts(
      this.props.registration.registration.key,
      from,
      size,
      searchText
    );
    // .then((res) => {
    // console.log("res", res);
    if (res.code == 0) {
      // Transform API data to match our expected format
      const transformedProducts = [];
      res.searchResult.map((product) => {
        let mrp = parseFloat(product.MRP);
        let retailPrice = parseFloat(product.RetailPrice) || 0;
        let discountPercentage = 0;
        let discountAmount = 0;

        if (mrp > 0 && mrp > retailPrice) {
          discountPercentage = Math.ceil(
            ((tmp.mrp - tmp.sellingPrice) / tmp.mrp) * 100
          );
          discountAmount = mrp - retailPrice;
        }

        let tmp = {
          id: product.key || product.SKU,
          name: product.Name || "Unnamed Product",
          sku: product.SKU || "N/A",
          barcode: product.BarCode,
          groupid: product.GroupID,
          image:
            product.Images && product.Images.length > 0
              ? product.Images[0]["ImagePath"]
              : "",
          mrp: mrp,
          retailPrice: retailPrice,
          discountPercentage: discountPercentage,
          discountAmount: discountAmount,
        };

        transformedProducts.push(tmp);
      });

      this.setState(
        {
          products: transformedProducts,
          totalItemsCount: res.totalItemsCount,
          loading: false,
        },
        () => {
          this.showPaginationStatus();
        }
      );
    } else {
      this.setState(
        {
          products: [],
          totalItemsCount: 0,
          loading: false,
        },
        () => {
          this.showPaginationStatus();
        }
      );
    }
  }

  handleSearch() {
    this.setState({ activePage: 1, recordFrom: 0 }, () => {
      this.loadProducts(this.state.searchText, 0, this.state.itemsCountPerPage);
    });
  }

  handlePageChange(pageNumber) {
    let recordFrom = (pageNumber - 1) * this.state.itemsCountPerPage;
    this.setState({ activePage: pageNumber, recordFrom: recordFrom }, () => {
      this.loadProducts(
        this.state.searchText,
        recordFrom,
        this.state.itemsCountPerPage
      );
    });
  }

  showPaginationStatus() {
    let paginationStatus;
    if (this.state.totalItemsCount === 0) {
      paginationStatus = "No records to display";
    } else if (this.state.recordFrom + 1 === this.state.totalItemsCount) {
      paginationStatus =
        "Showing " +
        this.state.totalItemsCount +
        " of " +
        this.state.totalItemsCount;
    } else if (
      this.state.recordFrom + this.state.itemsCountPerPage + 1 >
      this.state.totalItemsCount
    ) {
      paginationStatus =
        "Showing " +
        (this.state.recordFrom + 1) +
        " to  " +
        this.state.totalItemsCount +
        " of " +
        this.state.totalItemsCount;
    } else {
      paginationStatus =
        "Showing " +
        (this.state.recordFrom + 1) +
        " to  " +
        (this.state.recordFrom + this.state.itemsCountPerPage) +
        " of " +
        this.state.totalItemsCount;
    }
    this.setState({ paginationStatus: paginationStatus });
  }

  toggleProductSelection(productId) {
    this.setState((prevState) => {
      const selectedProducts = [...prevState.selectedProducts];
      const index = selectedProducts.indexOf(productId);

      if (index > -1) {
        selectedProducts.splice(index, 1);
      } else {
        selectedProducts.push(productId);
      }

      return { selectedProducts };
    });
  }

  toggleSelectAll() {
    if (this.state.selectedProducts.length === this.state.products.length) {
      this.setState({ selectedProducts: [] });
    } else {
      const allProductIds = this.state.products.map((product) => product.id);
      this.setState({ selectedProducts: allProductIds });
    }
  }

  toggleViewMode() {
    this.setState((prevState) => ({
      viewMode: prevState.viewMode === "grid" ? "table" : "grid",
    }));
  }

  handlePrint(format = "A4") {
    if (this.state.selectedProducts.length === 0) {
      alert("Please select at least one product to print");
      return;
    }

    const selectedProductsData = this.state.products.filter((product) =>
      this.state.selectedProducts.includes(product.id)
    );

    const is3Inch = format === "3inch";

    const printContent = `
      <html>
        <head>
          <title>Special Offers</title>
          <style>
            @page {
              margin: 0;
              ${is3Inch ? "size: 3in auto;" : "size: auto;"}
            }
  
            body {
              font-family: Arial, sans-serif;
              padding: ${is3Inch ? "0" : "0.2in"};
              margin: 0;
              display: flex;
              flex-wrap: wrap;
              justify-content: ${is3Inch ? "center" : "flex-start"};
            }
  
            .card {
              border: 1px solid #000;
              page-break-inside: avoid;
              box-sizing: border-box;
              padding: 10px;
              margin: ${is3Inch ? "0" : "5px"};
              width: 3in;
              height: 2in;
            }
  
            .offer {
              text-align: center;
              width: 100%;
              font-weight: bold;
              font-size: ${is3Inch ? "80px" : "80px"};
              line-height: 1;
              margin-top: 0px;
            }
  
            .off {
              font-size: 30px;
            }
  
            .product-name {
              font-size: 14px;
              margin-top: 10px;
              text-align: center;
            }

            .sellingprice{
             text-align: center;
              width: 100%;
              font-weight: bold;
              font-size: ${is3Inch ? "60px" : "60px"};
              line-height: 1;
              margin-top: 0px;
            }
  
            .price {
              display: flex;
              justify-content: space-between;
              font-size: 14px;
              margin-top: 10px;
            }
  
            @media print {
              .card {
                border: 1px solid #000 !important;
              }
            }
          </style>
        </head>
        <body>
          ${selectedProductsData
            .map((product) => {
              // Offer block logic
              const offerHTML =
                product.discountAmount == 0
                  ? `
                    <div class="offer">
                      ₹${product.retailPrice}/-
                    </div>
                  `
                  : `
                    <div class="offer">
                      ₹${product.discountAmount} <span class="off">Off</span>
                    </div>
                  `;

              return `
                <div class="card">
                  ${offerHTML}
  
                  <div class="product-name">${product.name}</div>
  
                  <div class="price">
                    <span>MRP: ₹${product.mrp}</span>
                    <span>Selling: ₹${product.sellingPrice}</span>
                  </div>
                </div>
              `;
            })
            .join("")}
  
          <script>
            window.onload = function() {
              window.print();
              setTimeout(() => window.close(), 200);
            };
          </script>
        </body>
      </html>
    `;

    const printWindow = window.open("", "_blank");
    if (printWindow) {
      printWindow.document.write(printContent);
      printWindow.document.close();
    } else {
      alert("Please allow popups for this site to print");
    }
  }

  renderGridViewbk() {
    return (
      <div className="row" style={{ marginTop: "20px" }}>
        {this.state.products.map((product) => (
          <div key={product.id} className="col-md-4 col-sm-6 col-xs-12">
            <div className="box box-widget widget-user-2">
              <div className="widget-user-header" style={{ padding: "0px" }}>
                <div className="widget-user-image">
                  <img
                    className="img-circle"
                    src={product.image}
                    alt={product.name}
                    style={{
                      width: "60px",
                      height: "60px",
                      objectFit: "cover",
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                </div>
                <h5 className="widget-user-username">{product.name}</h5>
                <h6 className="widget-user-desc">SKU: {product.sku}</h6>
              </div>
              <div className="box-footer no-padding">
                <ul className="nav nav-stacked">
                  <li>
                    MRP:
                    <span
                      className="pull-right"
                      // style={{ textDecoration: "line-through" }}
                    >
                      ₹{product.mrp.toFixed(2)}
                    </span>
                  </li>
                  <li>
                    Discount:
                    <span className="pull-right badge bg-red">
                      {product.discountPercentage}% OFF
                    </span>
                  </li>
                  <li>
                    Selling Price:
                    <span className="pull-right text-bold text-green">
                      ₹{product.sellingPrice.toFixed(2)}
                    </span>
                  </li>
                  <li>
                    You Save:
                    <span className="pull-right">
                      ₹{(product.mrp - product.sellingPrice).toFixed(2)}
                    </span>
                  </li>
                  <li style={{ padding: "10px" }}>
                    <div className="checkbox">
                      <label>
                        <input
                          type="checkbox"
                          checked={this.state.selectedProducts.includes(
                            product.id
                          )}
                          onChange={() =>
                            this.toggleProductSelection(product.id)
                          }
                        />
                        Select for Print
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderGridViewbkk() {
    return (
      <div
        className="row"
        style={{ marginTop: "20px", marginLeft: "-5px", marginRight: "-5px" }}
      >
        {this.state.products.map((product) => (
          <div
            key={product.id}
            className="col-md-4 col-sm-6 col-xs-12"
            style={{ padding: "5px" }}
          >
            <div
              className="box box-widget widget-user-2"
              style={{ height: "100%" }}
            >
              <div className="widget-user-header" style={{ padding: "0px" }}>
                <div className="widget-user-image">
                  <img
                    className="img-circle"
                    src={product.image}
                    alt={product.name}
                    style={{
                      width: "60px",
                      height: "60px",
                      objectFit: "cover",
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                </div>
                <h5 className="widget-user-username">{product.name}</h5>
                <h6 className="widget-user-desc">SKU: {product.sku}</h6>
              </div>
              <div className="box-footer no-padding">
                <ul className="nav nav-stacked">
                  <li>
                    MRP:
                    <span
                      className="pull-right"
                      style={{ textDecoration: "line-through" }}
                    >
                      ₹{product.mrp.toFixed(2)}
                    </span>
                  </li>
                  <li>
                    Discount:
                    <span className="pull-right badge bg-red">
                      {product.discountPercentage}% OFF
                    </span>
                  </li>
                  <li>
                    Selling Price:
                    <span className="pull-right text-bold text-green">
                      ₹{product.sellingPrice.toFixed(2)}
                    </span>
                  </li>
                  <li>
                    You Save:
                    <span className="pull-right">
                      ₹{(product.mrp - product.sellingPrice).toFixed(2)}
                    </span>
                  </li>
                  <li style={{ padding: "10px" }}>
                    <div className="checkbox">
                      <label>
                        <input
                          type="checkbox"
                          checked={this.state.selectedProducts.includes(
                            product.id
                          )}
                          onChange={() =>
                            this.toggleProductSelection(product.id)
                          }
                        />
                        Select for Print
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        ))}
        {/* Add empty divs to maintain grid alignment */}
        {this.state.products.length % 3 !== 0 &&
          Array.from({ length: 3 - (this.state.products.length % 3) }).map(
            (_, index) => (
              <div
                key={`empty-${index}`}
                className="col-md-4 col-sm-6 col-xs-12"
                style={{ padding: "5px", visibility: "hidden" }}
              >
                <div
                  className="box box-widget widget-user-2"
                  style={{ height: "100%", border: "none" }}
                ></div>
              </div>
            )
          )}
      </div>
    );
  }

  renderGridView() {
    return (
      <div className="products-grid-container" style={{ marginTop: "20px" }}>
        {this.state.products.map((product) => (
          <div key={product.id} className="product-card">
            <div className="box box-widget widget-user-2">
              <div className="widget-user-header" style={{ padding: "0px" }}>
                <div className="widget-user-image">
                  <img
                    className="img-circle"
                    src={product.image}
                    alt={product.name}
                    style={{
                      width: "60px",
                      height: "60px",
                      objectFit: "cover",
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                </div>
                <h5 className="widget-user-username">{product.name}</h5>
                <h6 className="widget-user-desc">SKU: {product.sku}</h6>
              </div>
              <div className="box-footer no-padding">
                <ul className="nav nav-stacked">
                  <li>
                    MRP:
                    <span
                      className="pull-right"
                      style={{ textDecoration: "line-through" }}
                    >
                      ₹{product.mrp.toFixed(2)}
                    </span>
                  </li>
                  <li>
                    Discount:
                    <span className="pull-right badge bg-red">
                      {product.discountPercentage}% OFF
                    </span>
                  </li>
                  <li>
                    Selling Price:
                    <span className="pull-right text-bold text-green">
                      ₹{product.sellingPrice.toFixed(2)}
                    </span>
                  </li>
                  <li>
                    You Save:
                    <span className="pull-right">
                      ₹{(product.mrp - product.sellingPrice).toFixed(2)}
                    </span>
                  </li>
                  <li style={{ padding: "10px" }}>
                    <div className="checkbox">
                      <label>
                        <input
                          type="checkbox"
                          checked={this.state.selectedProducts.includes(
                            product.id
                          )}
                          onChange={() =>
                            this.toggleProductSelection(product.id)
                          }
                        />
                        Select for Print
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderTableView() {
    return (
      <div>
        {/* className="table-responsive" style={{ marginTop: "20px" }} */}
        <table className="table table-bordered table-hover">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  checked={
                    this.state.selectedProducts.length ===
                      this.state.products.length &&
                    this.state.products.length > 0
                  }
                  onChange={this.toggleSelectAll}
                />
              </th>
              <th>Image</th>
              <th>Product Name</th>
              <th>SKU</th>
              <th>MRP</th>
              <th>Discount %</th>
              <th>Discount Amount</th>
              <th>Selling Price</th>
            </tr>
          </thead>
          <tbody>
            {this.state.products.map((product) => (
              <tr key={product.id}>
                <td>
                  <input
                    type="checkbox"
                    checked={this.state.selectedProducts.includes(product.id)}
                    onChange={() => this.toggleProductSelection(product.id)}
                  />
                </td>
                <td>
                  <img
                    src={product.image}
                    alt={product.name}
                    style={{
                      width: "50px",
                      height: "50px",
                      objectFit: "cover",
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                </td>
                <td>{product.name}</td>
                <td>
                  <div>{product.sku}</div>
                  <div>{product.barcode}</div>
                  <div>{product.groupid}</div>
                </td>
                <td style={{ textAlign: "right" }}>
                  ₹{product.mrp.toFixed(2)}
                </td>
                <td>
                  <span className="badge bg-red" style={{ textAlign: "right" }}>
                    {product.discountPercentage}% OFF
                  </span>
                </td>
                <td className="text-green" style={{ textAlign: "right" }}>
                  ₹{(product.mrp - product.sellingPrice).toFixed(2)}
                </td>
                <td
                  className="text-bold text-green"
                  style={{ textAlign: "right" }}
                >
                  ₹{product.sellingPrice.toFixed(2)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    return (
      <div className="content-wrapper">
        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="box">
                <div className="box-header with-border">
                  <div className="row">
                    <div className="col-md-6 col-xs-9">
                      <font style={{ fontSize: "30px" }}>
                        Smart Products Offers
                      </font>
                    </div>
                    <div className="col-md-6 col-xs-3">
                      <button
                        type="cancel"
                        className="btn btn-default pull-right btn-flat"
                        style={{ marginTop: "5px", marginLeft: "10px" }}
                        onClick={() => this.props.history.push("/home")}
                      >
                        <i className="fa fa-arrow-left"></i> Back
                      </button>
                    </div>
                  </div>
                </div>
                <div className="box-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Search by Product Name or SKU</label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control input-md"
                            value={this.state.searchText}
                            onChange={(evt) =>
                              this.setState({ searchText: evt.target.value })
                            }
                            onKeyPress={(e) =>
                              e.key === "Enter" && this.handleSearch()
                            }
                            placeholder="Enter product name or SKU"
                          />
                          <span className="input-group-btn">
                            <button
                              type="button"
                              className="btn btn-primary btn-flat"
                              onClick={this.handleSearch}
                            >
                              Search
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 text-right"></div>
                    <div className="col-md-4 text-right">
                      <button
                        className="btn btn-success btn-flat"
                        style={{ marginTop: "25px" }}
                        onClick={() => {
                          this.handlePrint("3inch");
                        }}
                        disabled={this.state.selectedProducts.length === 0}
                      >
                        <i className="fa fa-print"></i> Print Selected (
                        {this.state.selectedProducts.length})
                      </button>
                    </div>
                  </div>

                  {this.state.loading ? (
                    <div className="text-center">
                      <i className="fa fa-spinner fa-spin"></i> Loading
                      products...
                    </div>
                  ) : (
                    <>
                      {this.state.viewMode === "grid"
                        ? this.renderGridView()
                        : this.renderTableView()}

                      {this.state.totalItemsCount === 0 && (
                        <div className="alert alert-info text-center">
                          No products found matching your search criteria.
                        </div>
                      )}

                      {this.state.totalItemsCount > 0 && (
                        <div className="row">
                          <div className="col-md-12">
                            <div
                              className="pull-left"
                              style={{ marginTop: "25px" }}
                            >
                              {this.state.paginationStatus}
                            </div>
                            <div className="pull-right">
                              <Pagination
                                activePage={this.state.activePage}
                                itemsCountPerPage={this.state.itemsCountPerPage}
                                totalItemsCount={this.state.totalItemsCount}
                                pageRangeDisplayed={5}
                                onChange={this.handlePageChange}
                                itemClass="page-item"
                                linkClass="page-link"
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default withRouter(PincodeSmartProductOffer);
